import ErrorContextToFieldConverter from '@alfa-retail-react/components/converter/ErrorContextToFieldConverter';
import { UseFormReturnType } from '@alfa-retail-react/components/form-hook/useForm';

import { ValidationException } from 'app/api/exception/ValidationException';
import { getExceptionHandler } from 'app/api/getExceptionHandler';
import { ReturnAnalyticsType } from 'app/analytics/useAnalytics';
import { getConvertedErrors } from 'app/utils/ValidationUtils';

/**
 * Обработчик исключения, возникаемого при ошибке валидации к атрибутам заявки.
 * Представляет собой набор действий для исключения типа {@link ValidationException}
 * @param formContext
 * @param analytics
 * @param contextConverter
 */
export const validationExceptionHandler = (
    formContext: UseFormReturnType<any>,
    analytics: ReturnAnalyticsType,
    contextConverter?: ErrorContextToFieldConverter<any>,
) => {
    return getExceptionHandler(
        ValidationException.NAME,
        (exception: ValidationException) => {
            analytics?.fullEvent('ValidationExceptionEventOccurred');

            if (!contextConverter) {
                formContext.setFieldsErrors(exception.errors);
                return;
            }

            const convertedErrors = getConvertedErrors(
                exception.errors,
                contextConverter,
            );

            formContext.setFieldsErrors(convertedErrors);
        },
    );
};
